var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "MessageBubbleDots",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-message-bubble-dots","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M236 8.3H14.6C6.6 8.3.1 14.8.1 22.8v151.8c0 8 6.5 14.5 14.5 14.5h112l60.4 51.1c.8.7 1.9 1.1 2.9 1.1.6 0 1.3-.1 1.9-.4 1.6-.7 2.6-2.3 2.6-4.1v-47.7H236c8 0 14.5-6.5 14.5-14.5V22.8c0-8-6.5-14.5-14.5-14.5zm5.5 166.3c0 3-2.5 5.5-5.5 5.5h-50.6v47l-55.6-47-.1.2-.1-.1h-115c-3 0-5.5-2.5-5.5-5.5V22.8c0-3 2.5-5.5 5.5-5.5H236c3 0 5.5 2.5 5.5 5.5v151.8z"/>
  <circle cx="56.8" cy="100" r="19.8"/>
  <circle cx="124.8" cy="100" r="19.8"/>
  <circle cx="192.1" cy="100" r="19.8"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/message-bubble-dots.svg